import { useEffect, useState } from 'react';
import UAParser from 'ua-parser-js';

export default function usePlatformInfo() {
  const [results, setResults] = useState<UAParser.IResult | null>(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileWebview, setIsMobileWebview] = useState(false);

  useEffect(() => {
    const parser = new UAParser();
    const result = parser.getResult();

    setResults(result);

    if (result.device.type === 'mobile') {
      setIsMobile(true);
    }

    const browserName = result.browser.name?.toLowerCase();
    if (browserName?.includes('webview') || browserName?.includes('webkit')) {
      setIsMobileWebview(true);
    }
  }, []);

  return { isMobile, results, isMobileWebview };
}
